import { useModalContext } from 'utils/contexts/modal';
import { ModalAction, ModalState } from '../types';
import {
  CatalogModal,
  CreateSyncTakeover,
  DeleteSyncModal,
  EditSourceTakeover,
  RestrictCreateModal,
} from './modals';
import { CreateSourceTakeover } from './modals/CreateSourceTakeover';

export const DataWarehouseModals = () => {
  const { hideModal, modalState } = useModalContext<ModalState>();

  if (!modalState) return null;

  const { action = null, payload } = modalState;

  switch (action) {
    case ModalAction.EDIT_SOURCE:
      return <>{payload?.id && <EditSourceTakeover onClose={hideModal} id={payload.id} />}</>;
    case ModalAction.CONNECT_SOURCE:
      return <CatalogModal onClose={hideModal} />;
    case ModalAction.CREATE_SYNC:
      return <CreateSyncTakeover onClose={hideModal} sourceId={payload?.sourceId} />;
    case ModalAction.CREATE_SOURCE:
      return <CreateSourceTakeover onClose={hideModal} sourceType={payload?.sourceType} />;
    case ModalAction.DELETE_SYNC:
      return <DeleteSyncModal id={payload?.id} />;
    case ModalAction.RESTRICT_CREATE:
      return <RestrictCreateModal onClose={hideModal} />;
    default:
      return null;
  }
};
